import React from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";

import Filter from "components/global/Filter/Filter";

import searchIcon from "assets/icons/search.svg";
import { MIRROR_PRIORITIES } from "store/modals/slice";

type Filter = {
  value: string | number;
  label: string;
};

interface Props {
  filterByTitle: string;
  onFilterSearchByTitle: (e: string) => void;
  filterByCode: string;
  onFilterSearchByCode: (e: string) => void;
  handleApply: () => void;
}
const KeyPresetsFilter: React.FC<Props> = ({
  handleApply,
  onFilterSearchByTitle,
  onFilterSearchByCode,
  filterByTitle,
  filterByCode
}) => {
  const { t } = useTranslation();

  const handleApplyFilters = () => {
    handleApply();
  };

  const handleClearFilters = () => {
    onFilterSearchByTitle("");
    onFilterSearchByCode("");
  };

  return (
    <Filter
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      disabled
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("title"),
          boxTitle: t("searchByTitle"),
          icon: searchIcon,
          inputValue: filterByCode,
          inputType: "string",
          setInputValue: onFilterSearchByTitle,
        },
        {
          type: FilterItemTypes.input,
          title: t("code"),
          boxTitle: t("searchByCode"),
          icon: searchIcon,
          inputValue: filterByCode,
          inputType: "string",
          setInputValue: onFilterSearchByTitle,
        },
      ]}
    />
  );
};

export default KeyPresetsFilter;
